import ShTable from './src/main.vue'

ShTable.install = (Vue) => {
  Vue.component(ShTable.name, ShTable)
}
export default ShTable
